import { Button, Modal, Text } from "@alpacahq/ui/old";

interface SuccessModalProps {
  isOpen: boolean;
  onTransferClicked: () => void;
  onHomeClicked: () => void;
}

export const SuccessModal = ({
  isOpen,
  onTransferClicked,
  onHomeClicked,
}: SuccessModalProps) => (
  <Modal
    title=""
    isOpen={isOpen}
    onClose={onHomeClicked}
    size="sm"
    controls={
      <div className="flex w-full flex-col items-center gap-4">
        <Button
          variant="v2/filled"
          onClick={onHomeClicked}
          type="button"
          className="w-full"
        >
          Back to Home
        </Button>
        <Button
          variant="v2/ghost"
          onClick={onTransferClicked}
          type="button"
          size="v2/small"
          className="w-full"
        >
          View Your Transfer
        </Button>
      </div>
    }
  >
    <div className="flex flex-col items-center gap-4">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="49"
        height="48"
        viewBox="0 0 49 48"
        fill="none"
      >
        <path
          d="M42.5 24C42.5 27.5601 41.4443 31.0402 39.4665 34.0003C37.4886 36.9604 34.6774 39.2675 31.3883 40.6298C28.0992 41.9922 24.48 42.3487 20.9884 41.6541C17.4967 40.9596 14.2894 39.2453 11.7721 36.7279C9.25474 34.2106 7.54041 31.0033 6.84587 27.5116C6.15134 24.02 6.5078 20.4008 7.87018 17.1117C9.23255 13.8226 11.5397 11.0114 14.4997 9.03355C17.4598 7.05568 20.9399 6 24.5 6C29.2739 6 33.8523 7.89642 37.2279 11.2721C40.6036 14.6477 42.5 19.2261 42.5 24Z"
          fill="#FEE546"
        />
        <path
          d="M44 25.624C43.6814 29.3289 42.3111 32.8658 40.0506 35.8185C37.7901 38.7711 34.7333 41.0168 31.2399 42.2912C27.7464 43.5656 23.9617 43.8157 20.3309 43.0122C16.7001 42.2086 13.3743 40.3849 10.7449 37.7554C8.1154 35.1259 6.29161 31.8001 5.48808 28.1694C4.68455 24.5386 4.93469 20.7538 6.20909 17.2604C7.48349 13.767 9.72913 10.7102 12.6818 8.44963C15.6345 6.18911 19.1713 4.8189 22.8763 4.50021C23.0733 4.48396 23.2715 4.50667 23.4597 4.56704C23.6479 4.6274 23.8224 4.72425 23.9732 4.85205C24.124 4.97985 24.2481 5.13609 24.3385 5.31186C24.4289 5.48763 24.4838 5.67948 24.5 5.87646C24.5163 6.07345 24.4936 6.2717 24.4332 6.45991C24.3728 6.64812 24.276 6.82259 24.1482 6.97337C24.0204 7.12415 23.8642 7.24828 23.6884 7.33868C23.5126 7.42907 23.3208 7.48396 23.1238 7.50021C19.988 7.76964 16.9944 8.92909 14.4952 10.8421C11.9961 12.7552 10.0953 15.3423 9.01652 18.2989C7.93777 21.2556 7.72593 24.4589 8.40595 27.5319C9.08596 30.6049 10.6295 33.4197 12.855 35.6452C15.0805 37.8707 17.8954 39.4143 20.9683 40.0943C24.0413 40.7743 27.2446 40.5625 30.2013 39.4837C33.158 38.405 35.745 36.5042 37.6581 34.005C39.5712 31.5058 40.7306 28.5122 41 25.3765C41.0329 24.9786 41.2224 24.6101 41.5269 24.352C41.8314 24.094 42.226 23.9674 42.6238 24.0002C43.0216 24.033 43.3901 24.2225 43.6482 24.5271C43.9063 24.8316 44.0329 25.2261 44 25.624ZM23 13.5002V24.0002C23 24.398 23.1581 24.7796 23.4394 25.0609C23.7207 25.3422 24.1022 25.5002 24.5 25.5002H35C35.3979 25.5002 35.7794 25.3422 36.0607 25.0609C36.342 24.7796 36.5 24.398 36.5 24.0002C36.5 23.6024 36.342 23.2209 36.0607 22.9396C35.7794 22.6582 35.3979 22.5002 35 22.5002H26V13.5002C26 13.1024 25.842 12.7209 25.5607 12.4396C25.2794 12.1582 24.8979 12.0002 24.5 12.0002C24.1022 12.0002 23.7207 12.1582 23.4394 12.4396C23.1581 12.7209 23 13.1024 23 13.5002ZM30.5 9.00021C30.945 9.00021 31.3801 8.86825 31.7501 8.62102C32.1201 8.37379 32.4085 8.02238 32.5788 7.61125C32.7491 7.20012 32.7936 6.74772 32.7068 6.31126C32.62 5.8748 32.4057 5.47389 32.091 5.15922C31.7764 4.84455 31.3754 4.63026 30.939 4.54345C30.5025 4.45663 30.0501 4.50119 29.639 4.67148C29.2279 4.84178 28.8765 5.13017 28.6292 5.50018C28.382 5.87019 28.25 6.30521 28.25 6.75021C28.25 7.34695 28.4871 7.91925 28.909 8.3412C29.331 8.76316 29.9033 9.00021 30.5 9.00021ZM37.25 13.5002C37.695 13.5002 38.1301 13.3683 38.5001 13.121C38.8701 12.8738 39.1585 12.5224 39.3288 12.1113C39.4991 11.7001 39.5436 11.2477 39.4568 10.8113C39.37 10.3748 39.1557 9.97389 38.841 9.65922C38.5264 9.34455 38.1254 9.13026 37.689 9.04345C37.2525 8.95663 36.8001 9.00119 36.389 9.17148C35.9779 9.34178 35.6265 9.63017 35.3792 10.0002C35.132 10.3702 35 10.8052 35 11.2502C35 11.847 35.2371 12.4192 35.659 12.8412C36.081 13.2632 36.6533 13.5002 37.25 13.5002ZM41.75 20.2502C42.195 20.2502 42.6301 20.1183 43.0001 19.871C43.3701 19.6238 43.6585 19.2724 43.8288 18.8612C43.9991 18.4501 44.0436 17.9977 43.9568 17.5613C43.87 17.1248 43.6557 16.7239 43.341 16.4092C43.0264 16.0946 42.6254 15.8803 42.189 15.7934C41.7525 15.7066 41.3001 15.7512 40.889 15.9215C40.4779 16.0918 40.1265 16.3802 39.8792 16.7502C39.632 17.1202 39.5 17.5552 39.5 18.0002C39.5 18.5969 39.7371 19.1692 40.159 19.5912C40.581 20.0132 41.1533 20.2502 41.75 20.2502Z"
          fill="#3F3F46"
        />
      </svg>
      <h2 className="font-bold text-2xl">Transfer In Review</h2>
      <Text className="text-center text-gray-700 text-xs">
        We're processing your Portfolio Transfer now. You can check the status
        of your transfer status on your dashboard home page and portfolio
        transfer page.
      </Text>
    </div>
  </Modal>
);
